import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-primary-dark flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <div className="mb-6">
              <i className="fas fa-exclamation-triangle text-6xl text-accent-gold"></i>
            </div>
            <h1 className="font-display text-3xl font-bold text-white mb-4">
              Bir Hata Oluştu
            </h1>
            <p className="text-gray-400 mb-6">
              Üzgünüz, bir şeyler yanlış gitti. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-accent-copper to-accent-gold text-white font-semibold rounded hover:shadow-lg transition-all"
            >
              <i className="fas fa-redo mr-2"></i>
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
